import { useDroppable } from '@dnd-kit/core'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const ROOT_DROP_ID = 'knowledge-root'

/** Drop target for the top level, so a nested item can be dragged back out. */
export function RootDropZone({ children }: { children: ReactNode }) {
  const { setNodeRef, isOver } = useDroppable({ id: ROOT_DROP_ID })

  return (
    <div
      ref={setNodeRef}
      className={cn(
        'min-h-24 space-y-1 rounded-md border border-dashed border-transparent p-1',
        isOver && 'border-blue-400 bg-blue-50/50'
      )}
    >
      {children}
    </div>
  )
}
